/**
 * A failed fetch, not a crash: RouteErrorBoundary already wraps every private
 * route, so this is for the "the request came back 500" case where the rest of
 * the page is still usable.
 */
export default function ErrorState({
  title = 'Could not load this data',
  message,
  onRetry,
}) {
  return (
    <div
      role="alert"
      className="rounded-2xl border border-red-200 bg-red-50 p-6 text-red-800 dark:border-red-900/50 dark:bg-red-950/40 dark:text-red-200"
    >
      <h3 className="text-base font-semibold">{title}</h3>
      {message && <p className="mt-1 text-sm">{message}</p>}
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-4 rounded-lg bg-red-700 px-4 py-2 text-sm font-semibold text-white hover:bg-red-800"
        >
          Try again
        </button>
      )}
    </div>
  );
}
